// src/App.jsx
import React, { useState, useEffect } from 'react';
import { useWeb3 } from './hooks/useWeb3';
import { useContracts } from './hooks/useContracts';
import { Header } from './components/Header';
import { WrongNetworkBanner } from './components/WrongNetworkBanner';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { MintView } from './views/MintView';
import { StakeView } from './views/StakeView';
import { RewardsView } from './views/RewardsView';
import { MythologyView } from './views/MythologyView';
import { PrivacyView } from './views/PrivacyView';
import { DocsView } from './views/DocsView';
import { FAQView } from './views/FAQView';

const DunkPogeApp = () => {
  // Get last view from localStorage, default to 'mint'
  const [view, setView] = useState(() => {
    return localStorage.getItem('lastView') || 'mint';
  });
  
  // Save view to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('lastView', view);
  }, [view]);
  
  const { 
    account, 
    publicClient, 
    walletClient, 
    connectWallet, 
    disconnect, 
    isConnected,
    isWrongNetwork,
    switchToMainnet
  } = useWeb3();
  
  const { 
    stats, 
    saleActive, 
    nftBalance, 
    pogeBalance, 
    stakedTokens, 
    pendingRewards, 
    emissionRate,
    rewardPoolBalance,
    pogeStats,
    userAchievements,
    isApproved, 
    loading, 
    mint, 
    approveStaking,
    revokeApproval,
    stake, 
    unstake, 
    claim 
  } = useContracts(publicClient, walletClient, account);

  return (
    <div className="min-h-screen bg-black text-white font-mono">
      <Header 
        account={account}
        isConnected={isConnected}
        isWrongNetwork={isWrongNetwork}
        connectWallet={connectWallet}
        disconnect={disconnect}
        stats={stats}
      />
      
      {/* Wrong network warning - only shows when user is on wrong chain */}
      {isWrongNetwork && (
        <WrongNetworkBanner switchToMainnet={switchToMainnet} />
      )}
      
      <Navigation view={view} setView={setView} />

      <main className="max-w-7xl mx-auto px-4 py-8">
        {view === 'mint' && (
          <MintView 
            stats={stats}
            saleActive={saleActive}
            loading={loading}
            mint={mint}
            isConnected={isConnected}
            connectWallet={connectWallet}
            nftBalance={nftBalance}
            setView={setView}
          />
        )}
        {view === 'stake' && (
          <StakeView
            isConnected={isConnected}
            connectWallet={connectWallet}
            nftBalance={nftBalance}
            stakedTokens={stakedTokens}
            isApproved={isApproved}
            revokeApproval={revokeApproval}
            loading={loading}
            approveStaking={approveStaking}
            stake={stake}
            unstake={unstake}
            publicClient={publicClient}
            account={account}
            setView={setView}
            emissionRate={emissionRate}
          />
        )}
        
        {view === 'rewards' && (	        
          <RewardsView
            isConnected={isConnected}
            connectWallet={connectWallet}
            pogeBalance={pogeBalance}
            pendingRewards={pendingRewards}
            stakedTokens={stakedTokens}
            emissionRate={emissionRate}
            rewardPoolBalance={rewardPoolBalance}
            pogeStats={pogeStats}
            userAchievements={userAchievements}
            isApproved={isApproved}
            loading={loading}
            approveStaking={approveStaking}
            revokeApproval={revokeApproval}
            claim={claim}
            stats={stats}
            setView={setView}
            nftBalance={nftBalance}
          />
        )}
        {view === 'mythology' && (
          <MythologyView />
        )}
        {view === 'privacy' && (
          <PrivacyView />
        )}
        
        {view === 'docs' && <DocsView />}
        
        {view === 'faq' && <FAQView />}
      </main>
      
      <Footer setView={setView} />
    </div>
  );
};

export default DunkPogeApp;